import React, { RefObject, useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import FullCalendar from '@fullcalendar/react';
import { ErrorMessage } from '../../common';
import LoadingSpinner from '../../common/LoadingSpinner';
import { ROOT_URL } from '../../../config';
import { getErrorMessages } from '../../../utils';
import { executeHttpRequest } from '../../../epics/api';
import { TPageNotification } from '../../../types';


type TCopyInductionSessionProps = {
    notification: TPageNotification;
    closeModal: () => void;
    afterDate: string;
    beforeDate: string;
    calendarRef: RefObject<FullCalendar>;
}

export default function CopyInductionSession({
    notification,
    closeModal,
    afterDate,
    beforeDate,
    calendarRef,
}: TCopyInductionSessionProps) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [targetDate, setTargetDate] = useState(null);

    const isSingleDay = moment(beforeDate).diff(moment(afterDate), 'days') === 1;

    const handleConfirm = () => {
        setIsLoading(true);
        const startDate = isSingleDay ? targetDate.toISOString() : beforeDate;

        executeHttpRequest(
            `${ROOT_URL}induction-sessions/copy/`,
            'post',
            { date_from: afterDate, date_to: beforeDate, start: startDate },
            false,
        ).then(() => {
            setIsLoading(false);
            closeModal();
            notification.success('Success', 'Copied!');
            calendarRef.current?.getApi().gotoDate(moment(startDate).toDate());
        }).catch(err => {
            setIsLoading(false);
            setError(getErrorMessages(err));
        });
    };

    return (
        <div>
            <p className="modal-title">Copy Induction Session</p>
            <div className="copy-session-body">
                {isSingleDay ? (
                    <>
                        <p>Select the target date you want to copy the session to:</p>
                        <DatePicker
                            selected={targetDate}
                            onChange={date => setTargetDate(date)}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            calendarStartDay={1}
                        />
                    </>
                ) : (
                    <p>Are you sure you want to copy the sessions from the selected week to the next week?</p>
                )}
            </div>

            <button
                className="continue btn--round-big"
                onClick={handleConfirm}
                type="button"
                disabled={isLoading || (isSingleDay && !targetDate)}
            >
                {isLoading ? (
                    <LoadingSpinner
                        className="copy-session-spinner"
                        backgroundColor="white"
                    />
                ) : (
                    'CONFIRM'
                )}
            </button>
            {!isLoading &&
                <button className="back" onClick={closeModal} type="button">
                    CANCEL
                </button>
            }
            {!!error && <ErrorMessage message={error} />}
        </div>
    );
}
